/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcInventoryV1BooksOrderState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_INVENTORY_V1_BOOKS_ORDER_STATE_ENTITY_NAME = 'ixc.inventory.v1.BooksOrder';
export const ixcInventoryV1BooksOrderStateEntity = new schema.Entity<IxcInventoryV1BooksOrderState>(IXC_INVENTORY_V1_BOOKS_ORDER_STATE_ENTITY_NAME, {}, { idAttribute: 'booksOrderId' });

